import * as React from "react";
import { SVGProps, memo } from "react";

const SvgInvertColoredClock = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18.125a8.125 8.125 0 1 0 0-16.25 8.125 8.125 0 0 0 0 16.25ZM9.844 5.07a.625.625 0 0 0-.625.625v4.386c0 .075.013.146.037.213.044.148.142.28.287.364l2.797 1.615a.625.625 0 1 0 .625-1.083l-2.496-1.44V5.694a.625.625 0 0 0-.625-.625Z"
      fill="#4E5966"
    />
  </svg>
);

const Memo = memo(SvgInvertColoredClock);

export default Memo;
